import moment from 'moment'
import { createSelector } from 'reselect'

const ordemViagemIdaSelector = ({ conexao: { ordemViagemIda } }) => ordemViagemIda

const getOrdemViagemIda = createSelector(
	[ordemViagemIdaSelector],
	(ordemViagemIda) => ordemViagemIda
)


const Selectors = {
	getOrdemViagemIda,
}

export default Selectors
